import React, { Component }  from 'react'
import { connect } from 'react-redux'
import Numeral from 'numeral'
import {List, ListItem} from 'material-ui/List'
import Badge from 'material-ui/Badge'
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card'


import CommonTable from 'components/Table'
import { Column } from 'react-virtualized'
import calcTable from 'utils/calcTable'
import { allTable } from 'selectors/globalSearch'

import PropertyTable from '../properties/Table'
import TenantTable from '../tenants/Table'
import LeasesTable from '../leases/Table'
import ProjectsTable from '../projects/Table'
import TasksTable from '../tasks/Table'




const colors = {
	"For Rent": "#BA68C8",
	"Occupied": "#39cea8",
	"Retired": "#A0A0A0",
	"Out Of Service": "#000",
	"Not in Service": "#000"
}

let select = (state) => ({
	searchResault: allTable(state)
})

export class TableSearch extends Component{
	render(){
		let { props } = this

		return(
			<div style={{minHeight:"calc(100vh - 60px)"}}>

					<Card
						key="dashboard-property"
						initiallyExpanded={true}
						style={{backgroundColor: "#F5F5F5", border: "0px", boxShadow: "none", marginTop: "-2px", width:"calc(100vw-55px)"}}
					>
						<CardHeader
						  title={
							  <div>
								  <span style={{float: "left"}}>Properties</span>
								  <Badge
									   badgeContent={props.searchResault.property && props.searchResault.property.length || 0}
									   style={{marginTop: "-4px"}}
									   badgeStyle={{backgroundColor: '#009688', color:"white"}}
								  />
							  </div>
						  }
						  showExpandableButton={true}
						/>
						<CardText expandable={true} style={{padding:"0 0 0 50px", marginTop:"-20px"}}>
							{props.searchResault.property && props.searchResault.property.length &&
								<PropertyTable showAll={true} data={props.searchResault.property}/>
							}
						</CardText>
					</Card>





					<Card
						key="dashboard-tenant"
						initiallyExpanded={true}
						style={{backgroundColor: "#F5F5F5", border: "0px", boxShadow: "none", marginTop: "-2px", width:"calc(100vw-55px)"}}
					>
						<CardHeader
						  title={
							  <div>
								  <span style={{float: "left"}}>Tenants</span>
								  <Badge
									   badgeContent={props.searchResault.tenant && props.searchResault.tenant.length || 0}
									   style={{marginTop: "-4px"}}
									   badgeStyle={{backgroundColor: '#009688', color:"white"}}
								  />
							  </div>
						  }
						  showExpandableButton={true}
						/>
						<CardText expandable={true} style={{padding:"0 0 0 50px", marginTop:"-20px"}}>
							{props.searchResault.tenant && props.searchResault.tenant.length &&
								<TenantTable showAll={true} data={props.searchResault.tenant}/>
							}
						</CardText>
					</Card>
					{/*<List
					className={`dashboard-property`}
					style={{
						width: "calc(100% - 8px)"
					  , margin: "4px"
						, boxShadow: "0 0 5px rgba(0,0,0,0.5)"
					}}
				>

					<PropertyTable showAll={true} data={props.searchResault.property}/>
				</List>*/}

				{/*props.searchResault.tenant && props.searchResault.tenant.length && <List
					className={`dashboard-tenant`}
					style={{
						width: "calc(100% - 8px)"
					  , margin: "4px"
						, boxShadow: "0 0 5px rgba(0,0,0,0.5)"
					}}
				>
					<span style={{lineHeight:"60px", marginLeft:"60px", fontSize:"18px"}}>Tenants</span>
					<TenantTable showAll={true} data={props.searchResault.tenant}/>
				</List>*/}

				{/*props.searchResault.lease && props.searchResault.lease.length && <List
					className={`dashboard-leases`}
					style={{
						width: "calc(100% - 8px)"
					  , margin: "4px"
						, boxShadow: "0 0 5px rgba(0,0,0,0.5)"
					}}
				>
					<span style={{lineHeight:"60px", marginLeft:"60px", fontSize:"18px"}}>Leases</span>
					<LeasesTable showAll={true} data={props.searchResault.lease}/>
				</List>*/}


				{/*props.searchResault.project && props.searchResault.project.length && <List
					className={`dashboard-project`}
					style={{
						width: "calc(100% - 8px)"
					  , margin: "4px"
						, boxShadow: "0 0 5px rgba(0,0,0,0.5)"
					}}
				>
					<span style={{lineHeight:"60px", marginLeft:"60px", fontSize:"18px"}}>Projects</span>
					<ProjectsTable showAll={true} data={props.searchResault.project}/>
				</List>*/}

				{/*props.searchResault.task && props.searchResault.task.length && <List
					className={`dashboard-task`}
					style={{
						width: "calc(100% - 8px)"
					  , margin: "4px"
						, boxShadow: "0 0 5px rgba(0,0,0,0.5)"
					}}
				>
					<span style={{lineHeight:"60px", marginLeft:"60px", fontSize:"18px"}}>Tasks</span>
					<TasksTable showAll={true} data={props.searchResault.task}/>
				</List>*/}


		  </div>
		)
	}
}
export default connect(select)(TableSearch)



// WEBPACK FOOTER //
// ./src/routes/manager/dashboard/TableSearch.js